<template>
<div class="chapter">
<div class="inner_page">
<div class="pg-boilerplate" id="pgepubid00002">
<h2 class="calibre11" id="calibre_pb_0">PREFACE</h2>
</div>
<p class="calibre8">The trail journals of the first two government exploring
expeditions commanded by Lieutenant John
Charles Frémont, of the United States Engineers, and
advised by Kit Carson, mountain-man, are to be found
together published, spring of 1845, as reports transmitted
by the Secretary of War to the National Senate
and House.</p>
<p class="calibre8">These journals, recording peril and privation
faced for the wide public good and not for narrow
private gain, occupy their honored niche among the
golden archives of the Republic, and should be better
known in American school and home. The trails
themselves are eternal, denoted by names which have
endured, many of them, unto this day. Of the men
who may proudly and truthfully say, “I was with
Frémont,” or “I was with Carson,” few indeed remain;
and they will soon be gone, for man passes on,
while that which he has wrought survives.</p>
<p class="calibre8">The Oliver Wiggins in this narrative is real. I
have talked with him. He was the little boy under
the wagon, and he was the Taos lad who won the
Kit Carson rifle; he was upon the Frémont and
Carson First Expedition, and he was upon the Second<span id="pgepubid00003" title="[6]"><a id="Page_6" title="[6]"></a></span>
Expedition, by way of the Salt Lake to Fort Hall.
However, there he turned back, with the other Carson
men. In taking him through, as in having him ascend
the highest peak, voyage the Salt Lake in the rubber
boat, and be prominent in various such adventures, I
have added to his biography as told to me. Yet in
these credits I have not exalted him more than is his
due, for brave men rarely tell of all that they have
done well.</p>
<p class="calibre8">The other personages also are real, as members
of the Frémont or of the Carson party. Some of the
conversation is quoted from the Frémont reports; the
remainder is applied according to the characteristics
of the speakers, or is adapted from sentiments expressed
at divers times and places. The incidents of
course are based upon the Frémont journals, with sidelights
from the recollections of Major Wiggins, and
from the Frémont “Memoirs of My Life,” and like
chronicles bearing upon the day.</p>
<p class="calibre8">The two principals, Lieutenant (later Captain,
Colonel and General) Frémont, and Scout (later Colonel
and General) Christopher Carson, thought highly
each of the other; and this is warrant that they were
manly men. Manly men respect manly men. Lieutenant
Frémont said: “With me, Carson and truth
are the same thing;” and he refers to their “enduring
friendship.” Kit Carson left all—new ranch,
home, wife, dear associates—which, save honor, he
valued most, to accompany the lieutenant upon a<span id="pgepubid00004" title="[7]"><a id="Page_7" title="[7]"></a></span>
Third Expedition, and in every crisis of march, camp,
battle and politics he stuck stanchly to him. “I owe
more to Colonel Frémont than to any other man
alive,” he declared. Thus friend should stand by
friend.</p>
<p class="calibre8">This Third Expedition, of 1845–1846, again into
the Great Basin and across the Sierra Nevada Range
to the Valley of the Sacramento, was timed to the
conquest of California by American arms; but it is
another long story. Following the Third Expedition,
having resigned from the Army Colonel Frémont, in
1848–1849, voluntarily conducted a Fourth Expedition,
upon which many lives were lost to cold and
hunger amidst the winter mountains of south central
Colorado; and in 1853–1854, a Fifth Expedition, once
more across the Great Basin to California. In these
two expeditions Kit Carson did not take part. He
had the duties of home, and family, which also are
man’s duties; and the duties of agent over the Ute
and Apache Indians.</p>
<p class="calibre8">After that, came Civil War service for both
friends, in fields separate.</p>
<p class="right">Edwin L. Sabin.</p>
<p class="works"><span class="smcap1">San Diego, California.</span><br class="calibre4"/>
<span class="padl">May 15, 1912.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?4bccbd14